module.exports = __webpack_public_path__ + "4357beb823a5f8d65c260f045d9e019a.woff2";